'use client';

import { useState } from 'react';

export declare namespace BizzDashboard_SurveyPassword {
    export type Props = {
        password: string;
        /** Call to action announced to screen readers while the password is masked. */
        showLabel: string;
    };
}

export const BizzDashboard_SurveyPassword: React.FC<BizzDashboard_SurveyPassword.Props> = props => {
    /** Clicking pins the password open, so it survives the pointer leaving. */
    const [isPinned, setIsPinned] = useState(false);
    const [isPeeking, setIsPeeking] = useState(false);

    const isVisible = isPinned || isPeeking;

    return (
        <button
            type="button"
            onClick={() => setIsPinned(prev => !prev)}
            onPointerEnter={() => setIsPeeking(true)}
            onPointerLeave={() => setIsPeeking(false)}
            onFocus={() => setIsPeeking(true)}
            onBlur={() => setIsPeeking(false)}
            aria-pressed={isPinned}
            className="w-fit cursor-pointer text-xl font-medium tracking-wide underline decoration-dotted underline-offset-4"
            data-testid="bizz-dashboard-survey-report-password"
        >
            {/* The dots are decorative: a screen reader gets the password itself once revealed,
             * and the call to action while it is masked. */}
            <span aria-hidden="true">{isVisible ? props.password : '••••••••'}</span>
            <span className="sr-only">{isVisible ? props.password : props.showLabel}</span>
        </button>
    );
};
